import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { FadeUp } from "@/components/site/Reveal";

const checks = [
  "Gratuit",
  "Sans engagement",
  "Adapté à votre activité",
  "Aperçu personnalisé",
  "Aucun paiement nécessaire pour découvrir notre travail",
];

export const ApercuGratuit = () => (
  <section id="apercu" className="relative py-24 md:py-36 overflow-hidden" data-testid="apercu-section">
    <div className="glow-orb w-[600px] h-[600px] bg-blue-600/15 top-0 left-1/2 -translate-x-1/2" />
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="relative rounded-3xl border border-white/[0.09] bg-gradient-to-b from-white/[0.045] to-transparent p-8 md:p-16 overflow-hidden">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-violet-600/15 blur-[100px]" />
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center relative">
          <div>
            <FadeUp>
              <p className="section-label mb-5">— Notre promesse</p>
            </FadeUp>
            <FadeUp delay={0.08}>
              <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight leading-[1.05]">
                Aperçu gratuit de votre futur <span className="text-gradient">site internet.</span>
              </h2>
            </FadeUp>
            <FadeUp delay={0.16}>
              <p className="text-[var(--text-secondary)] text-base md:text-lg mt-6 leading-relaxed max-w-xl">
                Vous avez une idée mais vous ne savez pas à quoi votre site internet pourrait réellement ressembler ?
                Nous créons gratuitement un premier aperçu personnalisé, adapté à votre activité, sans engagement.
              </p>
            </FadeUp>
            <FadeUp delay={0.22}>
              <p className="font-display font-bold text-xl md:text-2xl mt-6 text-white">
                Découvrez votre futur site <span className="text-gradient">avant de vous engager.</span>
              </p>
            </FadeUp>
            <FadeUp delay={0.3}>
              <Link
                to="/demande"
                className="btn-gradient inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 font-semibold text-white mt-8"
                data-testid="apercu-cta"
              >
                Demander mon aperçu gratuit <ArrowRight size={17} />
              </Link>
            </FadeUp>
          </div>

          <div className="flex flex-col gap-3.5" data-testid="apercu-checklist">
            {checks.map((c, i) => (
              <motion.div
                key={c}
                initial={{ opacity: 0, x: 32 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.09, ease: [0.22, 1, 0.36, 1] }}
                className="glass rounded-2xl px-5 py-4 flex items-center gap-4"
              >
                <span className="flex-shrink-0 w-7 h-7 rounded-full bg-gradient-to-br from-blue-500/25 to-cyan-400/25 border border-cyan-400/30 flex items-center justify-center">
                  <Check size={14} className="text-[var(--accent-cyan)]" />
                </span>
                <span className="text-sm md:text-base text-white/90">{c}</span>
              </motion.div>
            ))}
            <FadeUp delay={0.5}>
              <p className="text-[var(--text-muted)] text-sm mt-2 leading-relaxed">
                Nous faisons ce métier par passion. Nous préférons vous montrer concrètement ce que nous pouvons
                créer plutôt que simplement vous promettre un résultat.
              </p>
            </FadeUp>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ApercuGratuit;
